import { _fetch as fetch } from '@hobs/utils/fetch';
import { toODataString } from '@progress/kendo-data-query';
import { GETAUDITLOGITEMS } from '@hobs/constants/serviceRequestAuditLog';

export function getAuditLogItems(path, params = { take: 10, skip: 0 }) {
  return dispatch => {
    dispatch(request());

    const oDataParams = toODataString(params);

    return fetch(`${path}?$count=true&${oDataParams}`)
      .then(response => {
        const result = {
          data: response.payload.value,
          total: response.payload['@odata.count']
        };
        dispatch(success(result));
        return { success: true, ...result };
      })
      .catch(error => {
        dispatch(failure(error.toString()));
        return { success: false };
      });
  };

  function request() {
    return { type: GETAUDITLOGITEMS.REQUEST };
  }
  function success(payload) {
    return { type: GETAUDITLOGITEMS.SUCCESS, payload };
  }
  function failure(error) {
    return { type: GETAUDITLOGITEMS.FAILURE, error };
  }
}
